module.exports = __webpack_public_path__ + "media/images/social-facebook-12c4e31f5256b96ed0d9c38fa861e359.svg";